import { useState } from 'react';
import { ShieldCheck, Inbox, MessageSquare, FileText, DollarSign, Users, Cpu, Target, Send, Settings as Cog, Menu, X, Zap } from 'lucide-react';

// Menu-items mappen op bestaande admin tab-ids. Geen dode items.
const ITEMS = [
  { id: 'control_center',  label: 'Control Center',     Icon: ShieldCheck },
  { id: 'approval_inbox',  label: 'Approval Inbox',     Icon: Inbox },
  { id: 'leads',           label: 'Leads',              Icon: MessageSquare },
  { id: 'ec_leads',        label: 'Energy Control Leads', Icon: FileText },
  { id: 'transactions',    label: 'Betalingen',         Icon: DollarSign },
  { id: 'pilot_devices',   label: 'Klant-app demo',     Icon: Users },
  { id: 'device_hub',      label: 'Devices',            Icon: Cpu },
  { id: 'ads',             label: 'Ads',                Icon: Target },
  { id: 'mail_settings',   label: 'Mail',               Icon: Send },
  { id: 'settings',        label: 'Instellingen',       Icon: Cog },
];

function NavItem({ item, active, onClick, available }) {
  const { Icon, label, id } = item;
  return (
    <button
      onClick={onClick}
      data-testid={`admin-sidebar-${id}`}
      title={available ? '' : 'Niet beschikbaar in jouw rol'}
      disabled={!available}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left text-sm transition-colors ${
        active
          ? 'bg-emerald-500/15 text-emerald-300 border border-emerald-400/30'
          : available
            ? 'text-white/70 hover:bg-white/5 hover:text-white border border-transparent'
            : 'text-white/30 cursor-not-allowed border border-transparent'
      }`}
    >
      <Icon className="w-4 h-4 shrink-0" />
      <span className="font-medium">{label}</span>
    </button>
  );
}

export default function AdminSidebar({ activeTab, onChange, availableTabIds = [] }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const go = (id) => {
    if (availableTabIds.includes(id)) {
      onChange(id);
      setDrawerOpen(false);
    }
  };

  const body = (
    <>
      <div className="flex items-center gap-2 px-3 mb-5">
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-emerald-500/20 text-emerald-300 border border-emerald-400/30">
          <Zap className="w-4 h-4" />
        </span>
        <span className="text-base font-semibold text-white" style={{ fontFamily: 'Outfit' }}>Powersure Admin</span>
      </div>
      <nav className="space-y-1">
        {ITEMS.map((it) => (
          <NavItem
            key={it.id}
            item={it}
            active={activeTab === it.id}
            available={availableTabIds.includes(it.id)}
            onClick={() => go(it.id)}
          />
        ))}
      </nav>
      <p className="text-[10px] text-white/35 mt-6 px-3 leading-snug">
        Owner cockpit · sidebar v1
      </p>
    </>
  );

  return (
    <>
      {/* Mobile trigger */}
      <button
        onClick={() => setDrawerOpen(true)}
        data-testid="admin-drawer-open"
        className="lg:hidden inline-flex items-center justify-center w-9 h-9 rounded-lg bg-white/8 border border-white/15 text-white/85 mb-3"
      >
        <Menu className="w-4 h-4" />
      </button>

      {/* Mobile drawer */}
      {drawerOpen && (
        <div className="lg:hidden fixed inset-0 z-50" data-testid="admin-drawer">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setDrawerOpen(false)} />
          <aside
            className="absolute left-0 top-0 bottom-0 w-72 p-4 pt-5 border-r border-white/10 overflow-y-auto"
            style={{ background: 'linear-gradient(180deg, #0e1b16 0%, #0a1410 100%)' }}
          >
            <button
              onClick={() => setDrawerOpen(false)}
              data-testid="admin-drawer-close"
              className="absolute top-3 right-3 w-8 h-8 inline-flex items-center justify-center rounded-md text-white/60 hover:text-white hover:bg-white/5"
            >
              <X className="w-4 h-4" />
            </button>
            {body}
          </aside>
        </div>
      )}

      {/* Desktop sticky sidebar */}
      <aside
        className="hidden lg:flex lg:flex-col lg:w-60 lg:shrink-0 lg:sticky lg:top-16 lg:max-h-[calc(100vh-5rem)] lg:overflow-y-auto lg:py-5 lg:px-3 lg:rounded-2xl lg:border lg:border-white/10 lg:mr-5"
        style={{ background: 'linear-gradient(180deg, #0e1b16 0%, #0a1410 100%)' }}
        data-testid="admin-sidebar"
      >
        {body}
      </aside>
    </>
  );
}
